var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"Page navigation example"}},[_c('ul',{staticClass:"pagination"},_vm._l((_vm.pageCount),function(key){return _c('li',{key:key,staticClass:"page-item",class:[ _vm.pageNumber === key - 1 ? 'active' : ''],on:{"click":function($event){return _vm.goToPage(key)}}},[_c('span',{staticClass:"page-link"},[_vm._v(_vm._s(key))])])}),0)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27ce267e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin-panel/components/common/Pagination.vue
// module id = nyhx
// module chunks = 0